export function updateTokenExpirationTime(tokenValidityDuration) {
    return tokenValidityDuration * 1000 + Date.now()
}

export function getToken() {
    return localStorage.getItem('jwt');
}

export function isAuthenticated() {
    const token = localStorage.getItem('jwt');
    if (!token) return false;

    // Optional: validate token expiration
    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        return payload.exp * 1000 > Date.now();
    } catch {
        return false;
    }
}

export function logout() {
    localStorage.removeItem('jwt');
}